import React from "react";
import ReferralWithdraw from "../ReferralWithdraw/ReferralWithdraw";

const ReferralIndex = ({ section, setSection, pendingEarnings }) => {
  let CurrentPage;
  switch (section) {
    case 0:
      CurrentPage = (
        <ReferralWithdraw
          setSection={setSection}
          pendingEarnings={pendingEarnings}
        />
      );
      break;
    default:
  }
  return <div>{CurrentPage}</div>;
};

export default ReferralIndex;
